import React from "react";
import Switch from "react-ios-switch";
import Select from "react-select";
import globalEnum from "../../../enums/globalEnum";
import { useResponsive } from "../../../hooks/useResponsive";
import { OrderFormState, User } from "../../../types/types";
import orderStatus = globalEnum.orderStatus;
import { orderService } from "./OrderService";
import Swal from "sweetalert2";

interface StylistSectionProps {
  form: OrderFormState;
  workers: User[];
  setWorkers: (workers: User[]) => void;
  getWorkers: (form: OrderFormState) => any;
  updateFormField: (field: string, value: any) => void;
  orderId: string;
}

const StylistSection: React.FC<StylistSectionProps> = ({
  form,
  updateFormField,
  workers,
  setWorkers,
  getWorkers,
  orderId,
}) => {
  const { isMobile, getSelectStyles } = useResponsive();

  const sendFeedbackSMS = async () => {
    const res = await orderService.sendFeedbackSMS(orderId);
    if (res.success) {
      Swal.fire({
        title: "موفق",
        text: "پیام نظرسنجی با موفقیت ارسال شد",
        icon: "success",
        confirmButtonText: "متوجه شدم",
      });
    } else {
      Swal.fire({
        title: "ناموفق",
        text: "خطا در ارسال پیام نظرسنجی",
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
    }
  };
  const handleWorkerChange = (e) => {
    const worker = workers.find((worker) => worker.id === e.value);
    updateFormField("worker", worker);
    updateFormField("workerPercent", worker.percent);
    updateFormField("workerId", e.value);
    updateFormField("shouldSendWorkerSMS", true);
  };

  const onGetWorkersClick = async () => {
    const res = await getWorkers(form);
    const newWorkers = res.data?.availableWorkers;
    if (
      form?.worker?.id &&
      !res.data.availableWorkers.find((e) => e.id == form?.worker?.id)
    ) {
      newWorkers.push(form?.worker);
    }

    setWorkers(res.data?.availableWorkers);
  };
  return (
    <div className="infoSection">
      <h1 className="dashBoardTitle">استایلیست</h1>
      <div className="orderInfoBox">
        <label className="sideBarTitle" htmlFor="name">
          درصد استایلیست از این سفارش
        </label>
        <input
          id="name"
          className="editProductInput"
          type="text"
          value={form?.workerPercent || ""}
          onChange={(e) => updateFormField("workerPercent", e.target.value)}
          placeholder="درصد استایلیست"
          aria-label="درصد استایلیست"
        />
        <label className="sideBarTitle" htmlFor="addressSelect">
          استایلیست های مرتبط
        </label>
        <Select
          id="addressSelect"
          className="addressInput dirRtl"
          styles={getSelectStyles()}
          options={[
            { value: undefined, label: "انتخاب کنید" },
            ...workers.map((e) => ({
              value: e.id,
              label: e.name + " " + e.lastName,
            })),
          ]}
          value={{
            value: form?.worker?.id || "",
            label: form?.worker?.id
              ? form.worker?.name + " " + form?.worker?.lastName
              : "انتخاب استایلیست",
          }}
          onChange={handleWorkerChange}
          placeholder="انتخاب استایلیست"
          isSearchable={false}
          aria-label="استایلیست"
          isDisabled={
            form?.status
              ? ![orderStatus.Paid, orderStatus.Assigned].includes(
                  form?.status as orderStatus,
                )
              : true
          }
        />
        <div className="orderWorkerList">
          {workers.map((e) => (
            <a href={`/user/edit/${e.id}`} target="_blank">
              {e.name + " " + e.lastName}
            </a>
          ))}
        </div>
        <div className="inputRow">
          <Switch
            checked={form?.shouldSendWorkerSMS || false}
            onChange={(checked) =>
              updateFormField("shouldSendWorkerSMS", checked)
            }
            aria-label="ارسال پیام"
          />
          <label className="sideBarTitle">
            برای مشتری و استایلیست پیام محول شدن ارسال شود{" "}
          </label>
        </div>
        <button
          className="addProductButton"
          onClick={onGetWorkersClick}
          aria-label="دریافت استایلیست های پیشنهادی"
        >
          استایلیست های پیشنهادی
        </button>
        {form.status == globalEnum.orderStatus.Done && (
          <button
            className="dashboardHeader keepRight"
            onClick={sendFeedbackSMS}
          >
            ارسال پیام نظرسنجی
          </button>
        )}
      </div>
    </div>
  );
};

export default StylistSection;
